module.exports = __webpack_public_path__ + "static/media/Ankita Chursenoff.b884b13c.png";